"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeleteModal = void 0;
var react_1 = __importStar(require("react"));
var ra_fetch_1 = require("ra-fetch");
var storybook_1 = require("@eyecons/storybook");
var prop_types_1 = __importDefault(require("prop-types"));
var DeleteModal = function (_a) {
    var api = _a.api, route = _a.route, params = _a.params, title = _a.title, simple = _a.simple, records = _a.records, setRecords = _a.setRecords, onDelete = _a.onDelete, setSubmitting = _a.setSubmitting;
    var _b = react_1.useState(''), deleteField = _b[0], setDeleteField = _b[1];
    var _c = ra_fetch_1.useApi(api).records(setRecords, records).delete(route, params), deleteRecord = _c[0], submitDelete = _c[1];
    var code = 'VERWIJDER';
    function onSubmit() {
        if (setSubmitting) {
            setSubmitting(true);
        }
        submitDelete().then(function () {
            if (setSubmitting) {
                setSubmitting(false);
            }
            if (onDelete) {
                return onDelete();
            }
            window.location.reload();
        });
    }
    return react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(storybook_1.Texts.Heading, { type: 'h3', appendClassname: 'mb-2' },
            "Verwijder ",
            title),
        react_1.default.createElement(storybook_1.Texts.Primary, { appendClassname: 'mb-4' }, !simple ? "Om deze " + title + " te verwijderen, typ \u201C" + code + "\u201D en klik op \u201CBevestigen\u201D" :
            "Weet u zeker dat deze " + title + " wilt verwijderen?"),
        !simple && react_1.default.createElement(storybook_1.Forms.Field, null,
            react_1.default.createElement(storybook_1.Forms.Input, { placeholder: code, onChange: function (value) { return setDeleteField(value); }, value: deleteField })),
        react_1.default.createElement(storybook_1.Forms.Buttons, { loading: deleteRecord.loading, errors: deleteRecord.errors, title: 'Bevestig', disabled: !simple ? deleteField !== code : false, submit: onSubmit }));
};
exports.DeleteModal = DeleteModal;
exports.DeleteModal.propTypes = {
    /**
     * The route to send the delete request to
     */
    route: prop_types_1.default.string,
    /**
     * The route params for the record to be deleted for example: {{id: 1}}
     */
    params: prop_types_1.default.object,
    /**
     * The record title to be deleted
     */
    title: prop_types_1.default.string,
};
